import { render, staticRenderFns } from "./CreateNewOrg.vue?vue&type=template&id=bd7323fa&scoped=true"
import script from "./CreateNewOrg.vue?vue&type=script&lang=js"
export * from "./CreateNewOrg.vue?vue&type=script&lang=js"
import style0 from "./CreateNewOrg.vue?vue&type=style&index=0&id=bd7323fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7323fa",
  null
  
)

export default component.exports